import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=244849a3"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports